import { render, staticRenderFns } from "./LoadingBarFile.vue?vue&type=template&id=628e8912&scoped=true"
import script from "./LoadingBarFile.vue?vue&type=script&lang=js"
export * from "./LoadingBarFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e8912",
  null
  
)

export default component.exports